import { ServiceInformationProps } from '@/modules/Service/types'
import ServiceStatementComponent from '../../shared/ServiceStatement'
import ViewSetting from '../../Conversant/shared/ViewSetting'
import ConfigPriceRanges from '../../Conversant/shared/ConfigPriceRanges'

const Statement: React.FC<ServiceInformationProps> = ({ service }) => {
    return (
        <>
            <ServiceStatementComponent serviceID={service?.service_id} />
            <ViewSetting
                service={service}
                peek_settings={[
                    'name',
                    'commitment_value',
                    'statementable',
                    // 'commitment_prepaid',
                ]}
            />
            <ConfigPriceRanges
                serviceID={service?.service_id}
                show_price_list
            />
        </>
    )
}

export default Statement
